var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 425.2 425.2",
    width: "100px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        width: 100%;\n        height: 100%;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.14,6.62C100.11,6.62,6.86,99.87,6.86,214.9s93.25,208.28,208.28,208.28,208.28-93.25,208.28-208.28S330.17,6.62,215.14,6.62ZM194.84,93.11c0-11.21,9.08-20.3,20.3-20.3s20.3,9.08,20.3,20.3v81.19c0,11.21-9.08,20.3-20.3,20.3s-20.3-9.08-20.3-20.3v-81.19ZM308.43,318.33c-51.53,51.53-135.05,51.53-186.58,0-51.53-51.53-51.53-135.05,0-186.58,7.92-7.92,20.78-7.92,28.69,0s7.94,20.78,0,28.69c-35.65,35.68-35.65,93.52,0,129.19,35.68,35.67,93.52,35.67,129.19,0,35.65-35.68,35.65-93.52,0-129.19-7.94-7.92-7.94-20.75,0-28.69,7.92-7.92,20.78-7.92,28.69,0,51.53,51.53,51.53,135.05,0,186.58Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.daa67946913b2af199a01a52d164ec80.svg";
export { ForwardRef as ReactComponent };